import { useState, useImperativeHandle, forwardRef } from "react";

import InputData from "../../components/InputData";
import InputIntButton from "./InputIntButton";

import "../css/InputInt.css";

export default forwardRef(
  ({ initValue, id = null, tabIndex = null, onChange }, ref) => {
    const [value, setValue] = useState(
      initValue !== "" && initValue != null ? initValue : "0"
    );

    const onChangeValue = (e) => {
      onFormatValue(e);
    };

    const addValue = () => {
      const v = (parseFloat(value) || 0) + 1;
      onFormatValue(v);
    };

    const subtractValue = () => {
      const v = (parseFloat(value) || 0) - 1;
      onFormatValue(v);
    };

    const onFormatValue = (val) => {
      const v = val === "" ? 0 : parseFloat(val);
      setValue(v);
      onChange(v);
    };

    const restart = () => {
      setValue(0);
    };

    useImperativeHandle(ref, () => ({
      restart,
    }));

    return (
      <div className="inputint">
        <InputIntButton label="-" onClick={subtractValue} />
        <InputData
          tabIndex={tabIndex}
          id={id}
          type="type-float2"
          size={5}
          maxLength={8}
          input={value}
          onChange={onChangeValue}
          onBlur={() => onFormatValue(value)}
        />
        <InputIntButton label="+" onClick={addValue} />
      </div>
    );
  }
);
